import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { TokenInterceptor } from '../interceptors/token.interceptor'
import { UserRoleHttpHeaderInterceptor } from '../interceptors/user-role.interceptor'
import { AuthEffects } from './auth.effects'
import { AuthGuard } from './auth.guard'
import * as fromAuth from './auth.reducer'
import { AuthService } from './auth.service'
import { OidcModule } from './oidc/oidc.module'
import { PlatformInterceptor } from '../interceptors/platform.interceptor'
import { LanguageInterceptor } from '../interceptors/language.interceptor'

@NgModule({ declarations: [],
    exports: [], imports: [OidcModule,
        StoreModule.forFeature(fromAuth.FEATURE_NAME, fromAuth.authReducer),
        EffectsModule.forRoot([AuthEffects])], providers: [
        AuthService,
        AuthGuard,
        { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UserRoleHttpHeaderInterceptor,
            multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: PlatformInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AuthModule {}
